<template>
  <teleport to="body">
    <transition name="fly">
      <div v-if="isActive" class="nudge-card" >
        <button class="close-x btn-close nudge-close" @click="close" aria-label="Close"></button>
        <div class="nudge-content">
          <br/>
          <a @click="showInstrModal"><u>Click to learn how to install the 3d pdf viewer.</u></a>
        </div>
        <button class="mute-btn" @click="mute">Mute for 2 weeks</button>
      </div>
    </transition>
  </teleport>
  <T3dHelpModal v-if="isHelpModalVisible" @close3dhelp="isHelpModalVisible = false"/>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';

import T3dHelpModal from '@/views/pages/T3dHelpModal.vue';

const store = useStore();
const isActive = computed(() => store.state.nudgeActive);
const isHelpModalVisible = ref(false)

//const isHelpModalVisible = computed(() => store.state.show3dInstrModal);

const close = () => {
  isHelpModalVisible.value = false;
  store.commit('HIDE_3D_NUDGE');
};
const mute = () => store.commit('MUTE_3D_NUDGE');


const showInstrModal = () => {
    console.log("Show 3D instruction modal");
    isHelpModalVisible.value = true;
    //store.commit('SHOW_3D_INSTR_MODAL');
    //close();
}

</script>

<style scoped>
.nudge-card {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 280px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  border: 1px solid rgba(0,0,0,0.05);
  z-index: 9999;
}

.mute-btn {
  background: transparent;
  border: none;
  color: #888;
  font-size: 0.75rem;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 1rem;
  padding: 0;
}

/* The Modern Fly-Up Animation */
.fly-enter-active {
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.fly-leave-active {
  transition: all 0.3s ease-in;
}
.fly-enter-from {
  transform: translateY(200%) scale(0.8);
  opacity: 0;
}
.fly-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
button, a {
  cursor: pointer;
}
</style>